exports.reduce = require('rxjs/internal/operators/reduce').reduce
